import { Layout, SlideoutDecorator, SlideoutDecoratorProps } from "@mcleod/components";
import { ProcessingStepper } from "./ProcessingStepper";
import { ProcessType } from "./ProcessingTypes";

export class ProcessingSlideout {

    constructor(processType: ProcessType, slideoutProps?: Partial<SlideoutDecoratorProps>) {
        const layout = Layout.getLayout("lme/integrations/ProcessingStepper") as ProcessingStepper;
        layout.processType = processType;
        new SlideoutDecorator({
            layout,
            width: "60%",
            overlayProps: { greyedBackground: true },
            addlComponents: [layout.buttonNextStep],
            fillVerticalSpace: true,
            ...(slideoutProps != null ? slideoutProps : {}),
        });
    }

}
